import { createTranslations } from '@npco/common-utils-translations'

export const modalContentTranslations = createTranslations({
  badge: 'Triple your interest',
  title:
    'Earn an amazing {baseInterestRate}% p.a. with a Zeller Savings Account this March.',
  description:
    'Grow your business savings faster with an even better interest rate by adding funds to a Zeller Savings Account. {termsApply}',
  point1ForActivatedSavings:
    'Add funds instantly from a Zeller Transaction Account.',
  point1ForNotActivatedSavings:
    'Activate instantly, add funds from a Zeller Transaction Account.',
  point2: 'Withdraw and access funds whenever you need them.',
  point3: 'Grow your balance with interest calculated daily, paid monthly.',
  point4: 'No minimum balance requirements or thresholds.',
  offerHeading: 'This limited-time offer ends 31 March 2024.',
  offerDescription: 'Add funds to earn more today.',
  termsApply: 'Terms Apply.',
})
